import ProjectHeroInStock from "../../../components/ProjectHero/InStock/ProjectHeroInStock";
import ProjectDetailsInStock from "../../../components/ProjectDetails/InStock/ProjectDetailsInStock";


function ProjectPageInStock() {
    return (
        <>
            <ProjectHeroInStock />
            <ProjectDetailsInStock />
        </>
    )
}

export default ProjectPageInStock;